(() => {
  function fitTitle(text, width, measure) {
    const chars = Array.from(text.trim().replace(/\s+/g, ' '));
    const fits = (s) => measure(s) <= width;
    function take(list, suffix = '') {
      let low = 0, high = list.length;
      while (low < high) {
        const mid = Math.ceil((low + high) / 2);
        if (fits(list.slice(0, mid).join('').trimEnd() + suffix)) low = mid;
        else high = mid - 1;
      }
      return low;
    }
    if (fits(chars.join(''))) return [chars.join('')];
    let cut = take(chars);
    const prefix = chars.slice(0, cut).join('');
    const fragment = prefix.match(/[A-Za-z]+$/)?.[0] || '';
    if (fragment.length > 0 && fragment.length <= 3 && /[A-Za-z]/.test(chars[cut] || '')) {
      const adjusted = cut - fragment.length;
      if (adjusted > 0) cut = adjusted;
    }
    cut = Math.max(1, cut);
    const first = chars.slice(0, cut).join('').trimEnd();
    const rest = Array.from(chars.slice(cut).join('').trimStart());
    const second = fits(rest.join('')) ? rest.join('') : rest.slice(0, take(rest, '…')).join('').trimEnd() + '…';
    return [first, second];
  }
  if (typeof module === 'object' && module.exports) { module.exports = fitTitle; return; }
  const mobile = matchMedia('(max-width:749px)');
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const saved = new WeakMap();
  let frame = 0;
  function render() {
    frame = 0;
    document.querySelectorAll('.product-card-wrapper .card__heading a').forEach(link => {
      let item = saved.get(link);
      const current = link.textContent.trim().replace(/\s+/g, ' ');
      if (!item || (current !== item.rendered && current !== item.text)) {
        item = {text:current, html:link.innerHTML, rendered:current, signature:''};
        saved.set(link, item);
      }
      if (!mobile.matches) {
        if (link.classList.contains('cv-smart-title')) {
          link.innerHTML = item.html;
          link.classList.remove('cv-smart-title');
          if (item.addedAria) link.removeAttribute('aria-label');
          item.rendered = item.text;
          item.signature = '';
        }
        return;
      }
      const width = link.getBoundingClientRect().width;
      if (width < 1 || !item.text) return;
      const style = getComputedStyle(link);
      ctx.font = style.font || [style.fontStyle,style.fontWeight,style.fontSize,style.fontFamily].join(' ');
      const spacing = parseFloat(style.letterSpacing) || 0;
      const signature = [item.text,width,ctx.font,spacing].join('|');
      if (signature === item.signature) return;
      const measure = text => ctx.measureText(text).width + Math.max(0,Array.from(text).length - 1) * spacing;
      const lines = fitTitle(item.text, Math.max(1,width - .5), measure);
      const children = lines.map(text => {
        const span = document.createElement('span');
        span.className = 'cv-smart-title__line';
        span.textContent = text;
        return span;
      });
      link.replaceChildren(...children);
      link.classList.add('cv-smart-title');
      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label',item.text);
        item.addedAria = true;
      }
      item.rendered = link.textContent.trim().replace(/\s+/g, ' ');
      item.signature = signature;
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(render); }
  const root = document.querySelector('#MainContent');
  if (!root) return;
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true});
  new ResizeObserver(schedule).observe(root);
  window.addEventListener('resize',schedule,{passive:true});
  mobile.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.fonts?.ready.then(() => { document.querySelectorAll('.product-card-wrapper .card__heading a').forEach(link => { const item = saved.get(link); if (item) item.signature = ''; }); schedule(); });
  schedule();
})();